// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"81401b53","501":"7c7eda9d","925":"866604ea"}[chunkId] + ".chunk.js";
};